import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'db-ecommerce-view-stats',
    templateUrl: './ecommerce-view-stats.component.html',
    styleUrls: ['./ecommerce-view-stats.component.scss'],
    standalone: false
})
export class EcommerceViewStatsComponent implements OnInit {
  @Input() stat;

  constructor() {
  }

  ngOnInit() {
  }

}
